import React from 'react';
import styled, { keyframes } from 'styled-components';
import { graphql, Link, useStaticQuery } from 'gatsby';


const bounceAnimation = keyframes`
  0% {transform: translateY(-45px); animation-timing-function: ease-in; opacity: 1;}
  24% {opacity: 1}40%{transform: translateY(-24px);animation-timing-function: ease-in}
  65% {transform: translateY(-12px);animation-timing-function: ease-in}
  82% {transform: translateY(-6px);animation-timing-function: ease-in}
  25%,55%,75% {transform: translateY(0);animation-timing-function: ease-out}
  100% {transform: translateY(-45px);animation-timing-function: ease-out;opacity: 1}
`;

const Arrow = styled.img`
  height: 34px;
  width: 56px;
  margin: 40px 0 0;
  animation: ${bounceAnimation} 1500ms infinite both;
`;

const ArrowContainer = styled.div`
  position: absolute;
  left: calc(50% - 28px);
  bottom: 0;
  width: 56px;
  height: 100px;
`;

const BouncingArrow = () => {
  const { arrow } = useStaticQuery(graphql`
   {
     arrow: file(name: {eq: "arrow_down"}) {
        publicURL
      }
    }
  `);

  return (
    <Link to="#sectionOne">
      <ArrowContainer>
        <Arrow src={arrow.publicURL} />
      </ArrowContainer>
    </Link>
  );
};

export default BouncingArrow;
